import {DataTableColumn} from "mantine-datatable";
import {NavLink} from "react-router-dom";
import {CodePipeline} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {formatTimestamp} from "../../../../utils/TableTimestamps.tsx";


export const useCodePipelinesTableColumns = () => {

    const columns: DataTableColumn<CodePipeline>[] = [
        {
            accessor: 'name',
            title: I18n.get('Name'),
            width: '1fr',
            render: (item: CodePipeline) => <NavLink to={`/code-pipelines/${encodeURIComponent(item.name)}`}>{item.name}</NavLink>,
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: CodePipeline) => formatTimestamp(item.created),
        },
    ];

    return {
        columns,
    };
};
